import request from '@/plugin/axios'

export function getOrganizationList(pageable) {
    return request({
        url: '/api/admin/queryStatisticsData',
        method: 'get',
        params: pageable
    })
}

export function select(pageable1) {
    return request({
        url: '/api/admin/queryStatisticsDataDetail',
        method: 'get',
        params: pageable1
    })
}